module.exports = __webpack_public_path__ + "img/20190606111622215.b4af5fd6.png";